export default "__VITE_PUBLIC_ASSET__218855a4__"